import { t } from "copy/t";

/**
 * The gallery's first-load state: the hero and the top of the photo grid in
 * outline, so the page settles into place instead of popping in around a
 * spinner. The channel colour is not known yet, so it draws in translucent
 * white over the page's default black.
 *
 * It carries `data-testid="loading-spinner"`, the repo's loading-indicator
 * contract that the e2e `waitForAppReady` waits on (see e2e/support/appReady.js).
 */
const BAR = "rounded-md bg-white/10 animate-pulse motion-reduce:animate-none";

const GallerySkeleton = () => (
  <div data-testid="loading-spinner" role="status" aria-label={t("galleryPage.loading")}>
    <div className="flex flex-col items-center px-4 pt-20 pb-12 sm:px-6 sm:pt-24 sm:pb-16 w-full" aria-hidden="true">
      <div className="flex flex-col gap-8 items-center w-full max-w-[640px]">
        <div className={`${BAR} h-10 w-44`} />
        <div className="flex flex-col gap-6 items-center w-full">
          <div className="flex flex-col gap-3 items-center w-full">
            <div className={`${BAR} h-9 sm:h-11 w-11/12 max-w-[520px]`} />
            <div className={`${BAR} h-9 sm:h-11 w-3/4 max-w-[400px]`} />
            <div className={`${BAR} mt-1 h-5 w-2/3 max-w-[360px]`} />
          </div>
          <div className={`${BAR} h-12 w-40 rounded-lg`} />
        </div>
      </div>
    </div>
    <div className="grid grid-cols-3 sm:grid-cols-5 lg:grid-cols-9 gap-[2px]" aria-hidden="true">
      {Array.from({ length: 18 }).map((_, i) => (
        <div key={i} className="aspect-[3/4] bg-white/[0.06] animate-pulse motion-reduce:animate-none" />
      ))}
    </div>
  </div>
);

export default GallerySkeleton;
